import { render, staticRenderFns } from "./SasAnxiety.vue?vue&type=template&id=d8ba2560&scoped=true&"
import script from "./SasAnxiety.vue?vue&type=script&lang=js&"
export * from "./SasAnxiety.vue?vue&type=script&lang=js&"
import style0 from "./SasAnxiety.vue?vue&type=style&index=0&id=d8ba2560&prod&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ba2560",
  null
  
)

export default component.exports